module.exports = __webpack_public_path__ + "img/DE01390.282f6e56.png";